import React, { useState } from 'react';
import { isNumber } from 'validate.js';

import DynamicDialog from '../../DynamicDialog/DynamicDialog';
import { NumberInput, ModalButton } from '../components/BranchComponents';

const NumberPromptModal = ({ open, onSubmit, onCancel, fieldText, title, initialValue = 0 }) => {
  const [number, setNumber] = useState(initialValue);

  const numberChangeHandler = e => {
    let { value } = e?.target || {};

    value = value.replace(/\D/g, '');

    if (value.length > 1 && value[0] === '0') {
      value = value.replace(/0/, '');
    }

    setNumber(Number(value));
  };

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit(number);
    setNumber(0);
  };

  return (
    <DynamicDialog
      open={open}
      title={title}
      contentText={fieldText || ''}
      field={<NumberInput min={0} value={number || ''} onChange={numberChangeHandler} />}
      actions={
        <form onSubmit={handleSubmit}>
          <ModalButton disabled={!(isNumber(number) && number > 0)} type="submit">
            Proceed
          </ModalButton>
          <ModalButton onClick={onCancel}>Cancel</ModalButton>
        </form>
      }
    />
  );
};

export default NumberPromptModal;
